/** @format */

import React, { useEffect, useState } from "react";
import $ from "jquery";
import axios from "axios";
import { CloseOutlined } from "@ant-design/icons";

import Card from "../../../../components/Card";
import { header } from "../../../../components/api/Header";
import Minimap from "../../../../components/map/Minimap";
import Table from "./Table";
import Chart0 from "../../../../components/Charts/Chart0";
import { getEnv } from "../../../../lib/env";

const AsosiynuqtalarSahifa = ({ periodTabs }) => {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [lmonth, setLmonth] = useState(month);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/republik/asosiy/index?sana=${month}`,
          header()
        );
        setData(res.data);
      } catch (e) {
        console.error("Xato:", e);
        alert("Bazaga ulanishda xato");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [month]);

  useEffect(() => {
    setMonth(lmonth);
  }, [lmonth]);

  const close = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
    setSelectedRowKeys("");
  };

  return (
    <div>
      <Table
        month={month}
        lmonth={lmonth}
        setLmonth={setLmonth}
        data={data}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        loading={loading}
        periodTabs={periodTabs}
      />

      {selectedRowKeys.length === 0 ? null : (
        <div
          className='data-content mt-3 mainpage'
          style={{ position: "relative" }}>
          <CloseOutlined
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              zIndex: 9,
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={close}
          />

          <Card>
            {(data[selectedRowKeys].lat !== null) &
            (data[selectedRowKeys].lan !== null) ? (
              <Minimap
                location={[
                  data[selectedRowKeys].lat,
                  data[selectedRowKeys].lan,
                ]}
                locations={[]}
                zoom={13}
              />
            ) : null}
          </Card>

          <Chart0 datas={data[selectedRowKeys]} month={month} />
        </div>
      )}
    </div>
  );
};

export default AsosiynuqtalarSahifa;
